export default __webpack_public_path__ + "static/media/5.2b4650d4.jpeg";